<template>
  <div>
    <Page :title="pageTitle" :isFullWidth="true">
      <template v-slot:action>
        <div class="Polaris-Page-Header__PrimaryActionWrapper">
          <div
            class="Polaris-Box Polaris-Box--printHidden"
            v-if="notificationConfig.orderShipping"
          >
            <button
              class="Polaris-Button"
              type="button"
              v-if="notificationConfig.orderShipping.isEnabled"
              @click="updateNotificationConfig(false)"
            >
              <span class="Polaris-Button__Content">
                <span class="Polaris-Button__Text">Deactivate</span>
              </span>
            </button>
            <button
              class="Polaris-Button Polaris-Button--primary"
              type="button"
              v-if="!notificationConfig.orderShipping.isEnabled"
              @click="updateNotificationConfig(true)"
            >
              <span class="Polaris-Button__Content">
                <span class="Polaris-Button__Text">Activate</span>
              </span>
            </button>
          </div>
        </div>
      </template>
      <template v-slot:default>
        <router-view></router-view>
      </template>
    </Page>
  </div>
</template>

<script>
import Page from "../../components/Common/Page";

export default {
  components: {
    Page
  },
  data() {
    return {
      pageTitle: "Order Shipping Update",
      notificationConfig: {},
      isLoading: false
    };
  },
  created() {
    this.getAutomationConfig();
  },
  methods: {
    async getAutomationConfig() {
      this.isLoading = true;
      this.$store.dispatch("getAutomationConfig").then(response => {
        this.notificationConfig = response.config;
        this.isLoading = false;
      });
    },
    updateNotificationConfig(isEnabled) {
      this.$store
        .dispatch("updateAutomationConfig", {
          requestParams: {
            notificationConfig: {
              ...this.notificationConfig,
              orderShipping: {
                ...this.notificationConfig.orderShipping,
                isEnabled
              }
            }
          }
        })
        .then(response => {
          this.notificationConfig = response.config;
          this.$store.dispatch("showNotification", {
            text: "Settings Updated"
          });
        });
    }
  }
};
</script>
